import { useState } from 'react';

import { useUpdatePieceDocumentMutation } from '@api/piece';
import { PieceDoc } from '@apiContract';

import { getUploadPieceDocUrl } from '@src/api/piece';

import { usePdf } from './usePdf';
import { usePiecePage } from './usePiecePage';

export const usePiecePdf = (pieceId: number, pieceDoc: PieceDoc | null) => {
  const [updatePieceDocument] = useUpdatePieceDocumentMutation();

  const { getCorrectImagesList, generatePdfFromImages } = usePdf();
  const { getActualPiecePageImage } = usePiecePage();

  const [loading, setLoading] = useState(false);

  const handleCreatePdfFromPages = async () => {
    if (!pieceDoc) return;

    try {
      setLoading(true);
      const docUploadUrl = await getUploadPieceDocUrl(pieceId);
      const imagesArray = await getCorrectImagesList(pieceDoc.piecePages.map((page) => getActualPiecePageImage(page)));
      const pdf = generatePdfFromImages(imagesArray, 'JPEG');
      const headers = { 'Content-Type': 'application/pdf' };
      await fetch(docUploadUrl.pdfUrl, { body: pdf, headers, method: 'PUT' });

      await updatePieceDocument({ id: pieceDoc.id, pdfKey: docUploadUrl.pdfKey, pieceId: pieceId }).unwrap();

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return { handleCreatePdfFromPages, loading };
};
